import React from 'react';
import { sanitizeText } from 'util/sanitizeText';

export function SafeText({ text }: { text: string }) {
  const clean = React.useMemo(() => sanitizeText(text), [text]);

  return <span dangerouslySetInnerHTML={{ __html: clean }} />;
}
